import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/shared";

const Notice = () => (
  <div className="mb-12 border-l-2 border-bz-amber bg-bz-ivory2 p-6" data-testid="legal-notice">
    <p className="text-sm leading-relaxed text-bz-slate">
      Contenu provisoire. Cette page devra être complétée et vérifiée avant la publication définitive du site.
    </p>
  </div>
);

export default function MentionsLegales() {
  return (
    <>
      <Seo
        title="Mentions légales — BENZENATI"
        description="Mentions légales de l'Atelier BENZENATI. Informations provisoires à compléter avant publication définitive."
      />
      <PageHero label="Informations" title="Mentions légales" testid="mentions-hero" />

      <section className="mx-auto max-w-3xl px-6 py-16 lg:py-24" data-testid="mentions-content">
        <Notice />

        <div className="space-y-10 text-bz-slate">
          <div>
            <h2 className="font-serif text-2xl text-bz-navy">Éditeur du site</h2>
            <p className="mt-4 leading-relaxed">
              BENZENATI — Atelier de veille et de décryptage.<br />
              Bourgogne-Franche-Comté · France.<br />
              Contact : consulting@benzenati.com
            </p>
            <p className="mt-3 text-sm italic">[Informations d'identification légale à compléter.]</p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-bz-navy">Responsable de la publication</h2>
            <p className="mt-4 leading-relaxed">[À compléter.]</p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-bz-navy">Hébergement</h2>
            <p className="mt-4 leading-relaxed">[Informations relatives à l'hébergeur à compléter.]</p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-bz-navy">Propriété intellectuelle</h2>
            <p className="mt-4 leading-relaxed">
              L'ensemble des contenus publiés sur ce site (textes, mises en perspective, éléments graphiques) relève de la propriété de BENZENATI, sauf mention contraire. Toute reproduction sans autorisation est interdite.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-bz-navy">Responsabilité</h2>
            <p className="mt-4 leading-relaxed">
              Les contenus publiés ont une vocation informative et pédagogique. Ils ne remplacent pas les conseils d'un professionnel habilité.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
